import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { useParams } from 'react-router-dom';
import { QuotationEditorContent } from '../../../quotation-editor/QuotationEditorContent';

export const QuotationEditor = () => {
    const { quoteId } = useParams();

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR',
    });

    return (
        <>
            <PageTitle>{t('TITLE')}</PageTitle>
            <QuotationEditorContent quoteId={quoteId} />
        </>
    );
};
